<template>
  <div class="container-xxl">
    <template v-if="!auth.estaLogado()">
      <div class="col-md-10 col-lg-8 col-xl-6 col-xxl-4 offset-md-1 offset-lg-2 offset-xl-3 offset-xxl-4 py-3">
        <titulo-duplo titulo="Login" class="mb-5" />
        <fieldset>
          <form id="login" @submit.prevent="login()">
            <InputText label="Login" placeholder="" v-model="user.email" />
            <InputText tipo="password" :btn_lock="true" label="Senha" v-model="user.senha" placeholder="" />
            <div class="d-grid gap-2 mx-auto">
              <button type="submit" class="btn btn-success btn-lg">
                Login
                <Spinner :visivel="false" id="loading" />
              </button>
            </div>
          </form>
          <div class="row">
            <div class="col-6 d-grid gap-2 mx-auto">
              <a href="/#formulario" class="btn btn-light mt-2 btn-block">Cadastre-se</a>
            </div>
            <div class="col-6 d-grid gap-2 mx-auto"><router-link to="/recuperar_senha" class="btn btn-light mt-2 btn-block">Esqueci minha
                senha</router-link></div>
          </div>
        </fieldset>
      </div>
    </template>
    <template v-else>
      <div class="col-md-10 offset-md-1 py-3 mt-5">
        <boas-vindas :nome="auth.nomeUser" />
      </div>
    </template>
  </div>
</template>

<script>
import InputText from '@/components/form/InputText.vue';
import TituloDuplo from '@/components/TituloDuplo.vue';
import Spinner from '@/components/Spinner.vue';
import { AuthStore } from '@/stores/Auth.js'
import { toastr } from '@/plugins/toast.js'
import { api } from '@/services/api'
import BoasVindas from '../components/login/BoasVindas.vue';
import { meta_default } from '@/assets/js/functions';

export default {
  name: '',
  components: {
    InputText,
    TituloDuplo,
    Spinner,
    BoasVindas,
  },
  data() {
    return {
      user: {
        email: '',
        senha: ''
      },
      auth: AuthStore(),
      disable: false,
      // api_get: `${process.env.VUE_APP_api_get}`
    }
  },
  metaInfo: {
    title: 'Acesso restrito',
    meta: meta_default()
  },
  methods: {
    async login() {
      const campos = document.querySelector('fieldset')
      const loading = document.querySelector('#loading')
      campos.setAttribute('disabled', 'disabled')
      loading.classList.remove('d-none');
      try {
        const data = await api.post('login', this.user)

        if (data.erro) {
          toastr.erro(data.erro)
        } else if (data.token && data.user) {
          this.auth.setToken(data.token)
          this.auth.setUser(data.user)
        } else {
          toastr.erro("Erro ao fazer o login. Tente novamente em alguns instantes.");
        }

      } catch (error) {
        toastr.erro("Erro ao fazer o login.");
      }
      loading.classList.add('d-none');
      campos.removeAttribute('disabled')
    }
  },
  mounted() {
  },
}
</script>

<style scoped>
.container-xxl {
  min-height: 68vh;
}
</style>